export const MACROCATEGORIAS = [
  'Naturaleza y aire libre',
  'Deporte y movimiento',
  'Gastronomía y encuentros',
  'Cultura y arte',
  'Vida social y música',
  'Talleres y aprendizaje',
  'Juegos y hobbies',
  'Bienestar',
  'Halloween',
];
